module.exports = __webpack_public_path__ + "static/img/jinkou.e0cb19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/jinkou.png
// module id = i9wH
// module chunks = 44